import { userInfoMapperSocket } from 'components/containers/utils/sockets/userInfoMapperSocket';
import { socketContextType } from 'index';
import { User } from 'models/User';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import SocketContext from 'socket-context';
import { RootState } from 'store';
import { validateAndCreateSocketIfExist } from 'utils/SocketValidator';
import { UserInfoMapperSocketHandler } from 'utils/UserInfoMapper';
import Participant from './backup/Participant';
import ImageComponent from './ImageComponent';
import SuccessModal from './Group_Session_Modals/SuccessModal';
import ShareBadgesModal from './Group_Session_Modals/ShareBadgeModal';
import BadgesModal from './Group_Session_Modals/BadgesModal';
import ActivityModal from './Group_Session_Modals/ActivityModal';
import ModalComp from './Group_Session_Modals/ModalComp';
import CrownGl from "../../../assets/images/crown_gl.png";
import CheckCircle from "../../../assets/images/check-circle.png";
import offlineuser from "../../../assets/images/offlineuser.png";
import mico from "../../../assets/images/mico.png";
import micOff from "../../../assets/images/micoff.png";
import videoOff from "../../../assets/images/videooff.png";
import { sessionModeType } from 'types/Constants';
import ParticipantNew from './backup/ParticipantNew';

type TableElementProps = {
    onPress: () => void,
    elementStyle: any,
    userData: any,
    nameStyle?: any,
    gl?: any,
    isExpandedView: boolean,
    groupLeaderEmail: string,
    hideKebab?: boolean
}
const TableElement = (props: TableElementProps) => {

    const { userData, groupLeaderEmail, gl, hideKebab } = props;
    const dispatch = useDispatch();
    const [showMenu, setShowMenu] = useState(false);
    const [activityMenu, setActivityMenu] = useState(false);
    // badges
    const [isShareBadgesModalVisible, setIsShareBadgesModalVisible] = useState(false);
    const [shareBadgesItem, setShareBadgesItem] = useState<null | any>()
    const [showBadges, setShowBadges] = useState(false)
    const [showShareBadges, setShareBadges] = useState(false);
    const [showReceivedBadges, setReceivedBadges] = useState(false);
    const [consoleDetailData, setConsoleDetailData] = useState<any>()
    const [showSwapSeat, setShowSwapSeat] = useState(false)

    const [message, setMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [checkBoxVal, setCheckBoxVal] = useState<any>();

    let userInfoHandler = new UserInfoMapperSocketHandler();
    let socketList: socketContextType[] = useContext(SocketContext);
    const session_id = useSelector((state: RootState) => state.live.settings.roomId);
    const batchData = useSelector((state: RootState) => state.live.settings.batch);
    const consoleDetails = useSelector((state: RootState) => state.live.settings.consoleDetails);
    const profileData = useSelector((state: any) => state?.auth?.user as User);
    const consumers = useSelector((state: any) => state.live.settings?.consumers);
    const producers = useSelector((state: any) => state.live.settings?.producers);
    const sessionData: any = useSelector((state: any) => state.live.settings.sessionData);
    const sessionSettingData = useSelector((state: any) => state?.session?.sessionSettingData);
    const sessionDetails = useSelector((state: any) => state?.live.settings.session);
    const myGroup = useSelector((state: any) => state?.live.settings?.myGroup);
    const [isVideoOn, setIsVideoOn] = useState<boolean | undefined>(false);
    const [isAudioOn, setIsAudioOn] = useState(false);

    const [requestToSwapSeat, setRequestToSwapSeat] = useState(false);

    let userMicState = useSelector((state: any) => state.countReducer?.micState);
    const [amImute, setAmImute] = useState(false);


    const [myStream, setMyStream] = useState<any>({})
    const [otherStream, setOtherStream] = useState<any>({})
    const [allStream, setAllStream] = useState<any>({})

    const [tableData, setTableData] = useState<any>([])
    const [myTableData, setMyTableData] = useState<any>([]);
    const [isUserInPrivateChat, setIsUserInPrivateChat] = useState(false);
    const [glData, setGlData] = useState<any>([])
    const [acceptedBy, setAcceptedBy] = useState<string | null>(null);
    const [mute, setMute] = useState(false);

    useEffect(() => {
        userInfoHandler = validateAndCreateSocketIfExist(session_id, handleOnMessage, socketList);
    }, []);

    const handleOnMessage = async (_data: any) => {
        const data = JSON.parse(_data);

        // Check for leave or end private chat
        if (data.type === 'private_video_chat') {
            if (data.sub_type === 'leave_private_video_chat' || data.sub_type === 'ended_private_chat') {
                setIsUserInPrivateChat(false);
                setAcceptedBy(null);
            }
        }

        // Handle participant_kabab_menu
        if (data?.type === 'participant_kabab_menu' && data?.sub_type === 'choose_as_a_group_leader') {
            setGlData(data.table_data);
        }

        // Handle private chat acceptance
        if (data?.type === 'private_video_chat' && data?.sub_type === 'accepted_private_chat') {
            if (data.acceptedBy) {
                setAcceptedBy(data.acceptedBy);
                setIsUserInPrivateChat(true);
            }
        }
    };

    const setParticipants = (td: any[]) => {
        let from = 0;
        let to = batchData?.sittingStyle[0]?.nos_of_participant_on_table;
        td.map((v: any, i: number) => {
            let p = batchData?.participants?.slice(from, to)
            from = to;
            to = to + batchData?.sittingStyle[0]?.nos_of_participant_on_table;
            td[i].seats = p
        })
        setTableData([...td])
    }

    useEffect(() => {
        if (batchData && batchData?.sittingStyle?.length > 0) {
            if (batchData?.sittingStyle && batchData?.sittingStyle[0] && batchData?.sittingStyle[0]?.table && !batchData?.sittingStyle[0]?.assign_manually) {
                setParticipants(JSON.parse(batchData?.sittingStyle[0]?.table))
            }
            else {
                setTableData(JSON.parse(batchData?.sittingStyle[0]?.table))
            }
        }
    }, [batchData])

    useEffect(() => {
        if (tableData && tableData?.length > 0) {
            tableData?.map((e: any) => {
                let _myTable = e?.seats?.filter((x: any) => x?.email?.toLowerCase() == profileData?.email?.toLowerCase())
                if (_myTable && _myTable.length > 0) {
                    let _myTbl = e?.seats?.map((t: { email: any; }) => t?.email);
                    setMyTableData(_myTbl)
                }
            })
        }
    }, [tableData])

    useEffect(() => {
        if (Object.keys(myStream).length > 0 || Object.keys(otherStream).length > 0) {
            const mergedStreams = { ...otherStream, ...myStream };
            console.log('Merging streams:', mergedStreams);
            setAllStream(mergedStreams);
        }
    }, [myStream, otherStream]);

    useEffect(() => {
        console.log('allStream1 my', allStream);
    }, [allStream])



    useEffect(() => {
        const producersArray = Object.values(producers);

        const videoProducer: any = producersArray?.find(
            (producer: any) => producer.kind === 'video'
        );
        if (videoProducer) {
            const stream = new MediaStream();
            stream.addTrack(videoProducer.track);
            setMyStream({ [profileData?.email]: stream })
        } else {
            setMyStream({ [profileData?.email]: { toURL: () => { } } })
        }
    }, [producers]);
    const groupBy = (objectArray: any[], property: string) => {
        return objectArray.reduce(function (acc, obj) {
            var key = obj[property];
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
    }

    useEffect(() => {
        if (consumers) {
            let _consumers = Object?.values(consumers);
            let newConsumerArray = groupBy(_consumers, "peerId");
            let _newConsumerArray = Object.values(newConsumerArray);
            let origianlStreamArray: any;
            _newConsumerArray &&
                _newConsumerArray?.map((c: any, i: number) => {
                    let stream = new MediaStream();
                    let peerId: any;
                    c?.map((c1: any, i1: number) => {
                        stream?.addTrack(c1?.track);
                        peerId = c1?.peerId;
                    });
                    origianlStreamArray = { ...origianlStreamArray, [peerId]: stream };
                });
            setOtherStream(origianlStreamArray);
            return
        }
    }, [consumers]);

    const handleBadges = () => {
        setShowBadges(false);
        dispatch({
            type: 'RESET_NEW_BADGE_COUNT',
        });
    }

    const shareVisitingCard = () => {
        let request = {
            emailId: userData.participant_email || userData.email,
            id: sessionData.sessionId, //number;
            sessionName: sessionData.session.session_name, //string;
            sessionDate: sessionData.session_start_date, //string;
            sessionId: sessionData.sessionId
        };
        // postDataWithToken(request, mobile_siteConfig.SHARE_VISITING_CARD)
        //     .then(async (res: any) => {
        //         setShowMenu(false)
        //         if (res.code == 200 || res.code == 201) {
        //             setMessage(res.message);
        //             setShowModal(true)
        //         } else {
        //             setMessage(res.message);
        //             setShowModal(true)
        //         }
        //     })
        //     .catch((error: any) => {
        //         setMessage('we can not find the visiting card for that user you can try again sometime later....');
        //         setShowModal(true)
        //     });
    }

    const muteuser = () => {
        let _isUserinMyGroup = myGroup?.seats?.find((x: any) => x?.email == props?.userData?.email || x?.email == props?.userData?.participant_email)
        if (_isUserinMyGroup) {
            return false
        }
        else {
            return true
        }
    }

    const getUserIdByEmail = (email: string, participants: any[]) => {
        return participants?.find((x) => x?.email?.toLowerCase() == email?.toLowerCase())
    }

    const CheckBox = (item: any) => {
        let email = [item?.email]
        setCheckBoxVal(() => {
            return email
        });
    };

    const goToVideoChat = () => {
        setShowMenu(false);
        let me = getUserIdByEmail(profileData?.email, batchData?.participants)
        let chatBoxId = `${sessionData.id}_${me?.id}`
        let payload = {
            type: 'video_chat_request',
            sub_type: 'request_for_private_chat',
            room_id: sessionData?.id,
            chatBoxId: chatBoxId,
            data: {
                type: 'request_for_video_chat',
                requestorName: profileData?.name,
                requestorEmail: profileData?.email,
                requestedWithEmail: userData?.email || userData?.participant_email,
            },
        }
        setShowMenu(false);
        userInfoHandler = validateAndCreateSocketIfExist(sessionData?.id, () => { }, socketList);
        userInfoHandler?.sendMessage(JSON.stringify(payload))
    }

    const sendRequestToSwapSeat = () => {
        if (userData) {
            var selectedElement = batchData?.participants.find(function (element: { email: any; }) {
                return element.email === profileData?.email;
            });
            var dataToSend = {
                "type": "networking_mode",
                "sub_type": "raise_swap_seat",
                "swap_raise_by": {
                    "seat_number": selectedElement?.id,
                    "participant_id": selectedElement?.id,
                    "participant_name": selectedElement?.name,
                    "participant_email": selectedElement?.email,
                    "profilePhoto": selectedElement?.profilePhoto,
                },
                "swap_raise_for": {
                    "seat_number": props?.userData?.seat_number,
                    "participant_id": props?.userData?.id || props?.userData?.participant_id,
                    "participant_name": props?.userData?.name || props?.userData?.participant_name,
                    "participant_email": props?.userData?.email || props?.userData?.participant_email,
                    "profilePhoto": props?.userData?.profilePhoto
                },
                "room_id": sessionData?.id,
                "timestamp": 530
            }
            userInfoHandler = validateAndCreateSocketIfExist(sessionData?.id, () => { }, socketList);
            userInfoHandler.sendMessage(JSON.stringify(dataToSend))
        }
    }

    useEffect(() => {
        setConsoleDetailData(consoleDetails)
    }, [consoleDetails]);

    useEffect(() => {
        if (sessionDetails?.privateVideoChat?.participants === undefined) {
            return
        }

        if (sessionDetails?.privateVideoChat?.participants.length > 0 && sessionDetails?.privateVideoChat?.participants !== undefined) {
            console.log('list of trainee on the private video chat:::::::::::::::2', sessionDetails?.privateVideoChat?.participants)
            const data = sessionDetails?.privateVideoChat?.participants;
            const searchValue = props?.userData?.email || props?.userData?.participant_email;
            // Filter out undefined values
            const filteredData = data.filter((item: any) => item !== undefined);
            // Check if the search value exists in the filtered data
            const exists = filteredData.includes(searchValue) && !allStream[searchValue];
            // when user is in private chat his data will not be in peers of current room.
            if (exists) {
                setIsUserInPrivateChat(true)
            } else {
                setIsUserInPrivateChat(false)
            }
        }
    }, [sessionDetails]);

    const getFirsrLetterOfName = (name: string) => {
        if (name) {
            // Get the first letter of the first name
            var firstLetterFirstName = name.charAt(0);
            // Initialize the variable for the first letter of the second name
            var firstLetterSecondName = '';
            // Check if there is a space character in the name
            var spaceIndex = name.indexOf(' ');
            if (spaceIndex !== -1) {
                // If there is a space, get the first letter of the second name
                firstLetterSecondName = name.charAt(spaceIndex + 1);
            }
            return firstLetterFirstName.toUpperCase() + firstLetterSecondName.toUpperCase();
        }
    }

    useEffect(() => {
        console.log('allStream:::::::::::::::::::1', allStream)
        var data = allStream[props?.userData?.email || props?.userData?.participant_email]
        if (data !== undefined) {
            // when data is not there isVideoOn will be set to undefined.
            var hasVideoTrack = data?._tracks?.some(function (track: { kind: string; }) {
                return track.kind === "video";
            });
            setIsVideoOn(hasVideoTrack);


            var hasAudioTrack = data?._tracks?.some(function (track: { kind: string; }) {
                return track.kind === "video";
            });
            setIsAudioOn(hasAudioTrack)
        } else {
        }
    }, [allStream, producers, consumers]);

    useEffect(() => {

        if ((props?.userData?.email || props?.userData?.participant_email) !== profileData?.email) {
            if (consumers) {
                let _consumers = Object?.values(consumers);
                let newConsumerArray = groupBy(_consumers, 'peerId');
                let _newConsumerArray = Object.values(newConsumerArray);
                _newConsumerArray && _newConsumerArray?.map((c: any, i: number) => {
                    c.every(function (obj: { codec: string; peerId: any; remotelyPaused: boolean; }) {
                        if (obj?.codec === 'opus' && obj?.peerId === (props?.userData?.email || props?.userData?.participant_email)) {
                            if (obj?.remotelyPaused === false) {

                                setMute(true);
                                return
                            }
                            if (obj?.remotelyPaused === true) {

                                setMute(false);
                                return
                            }
                        }
                    });
                })
            }
        }
    }, [isVideoOn, consumers])


    useEffect(() => {
        if ((props?.userData?.email || props?.userData?.participant_email) === profileData?.email) {
            if (userMicState === 'unsupported') {
                // on
                setAmImute(true);
            }
            if (userMicState === 'on') {
                // off
                setAmImute(false);
            }
        }
    }, [userMicState]);

    const sendBadges = (userSelected: any) => {
        if (checkBoxVal?.length < 1) {
            return;
        }
        saveSendedBadged(userSelected)
        let objUserReactionData = {
            reaction_type: userSelected?.name,
            reaction_sub_type: userSelected?.name,
            reacted_by: profileData?.name,
            reacted_by_type: 'trainee',
            sent_to: checkBoxVal,
        };

        userInfoHandler = validateAndCreateSocketIfExist(session_id, () => { }, socketList);
        userInfoHandler.sendMessage(
            JSON.stringify({
                type: 'show_badges',
                sub_type: 'badge_share_count',
                user_badge_data: objUserReactionData,
                room_id: sessionData?.id
            }),
        );
    };

    const saveSendedBadged = async (selectedUser: any) => {
        let senderId = profileData.id;
        let data = {
            "achievementName": selectedUser?.name,
            "sessionId": sessionData?.id,
            "programId": sessionData?.session?.program?.id,
            "receiverEmail": checkBoxVal,
            "senderId": senderId,
            "senderName": profileData?.name
        };
        // postDataWithToken(data, mobile_siteConfig.SAVE_BADGES)
        //     .then((res) => {
        //         console.log("save badges res -->", res)
        //         if (res?.code == 200) {
        //             setMessage(res?.message);
        //             setShowModal(true);
        //             setCheckBoxVal([]);
        //         }
        //     })
        //     .catch(error => {
        //         console.log('save badges error -->', error);
        //     });
        // update session meta info 
        let _trainee_list: any = []
        batchData?.participants?.forEach((e: any) => {
            if (checkBoxVal?.includes(e?.email)) {
                _trainee_list.push(e?.id)
            }
            else {
                return
            }
        })
        let objBody = {
            sessionSegmanetId: session_id,
            type: selectedUser?.name,
            traineeList: _trainee_list?.toString()
        };
        // postDataWithToken(objBody, mobile_siteConfig.MOB_UPDATE_SESSION_META_INFO)
        //     .then((res: any) => {
        //         const { response } = res;
        //         if (response.data && typeof response.data == 'object') { } else { }
        //     })
        //     .catch((error: any) => { console.log(error) });
    }

    const showPeerKababMenu = (source: { myEmail: string }, target: { clickedEmail: string }, interactionEnabled: string, sessionMode: string) => {
        let showMenu = false;
        if (sessionMode === sessionModeType.NETWORKING_MODE) {
            if (source.myEmail === target.clickedEmail) {
                // if both the emails are same mean I am clicking on my feed only.
                showMenu = false;
            } else {
                showMenu = true;
            }
        } else if (sessionMode === sessionModeType.ACTIVITY_MODE) {
            return interactionEnabled && source.myEmail !== target.clickedEmail;
        } else if (sessionMode === sessionModeType.INSTRUCTOR_MODE) {
            showMenu = false;
        }
        return showMenu;
    }

    return (
        <>
            <div className="relative">
                {/* Crown for group leader */}
                {groupLeaderEmail &&
                    (groupLeaderEmail === props?.userData?.email || groupLeaderEmail === props?.userData?.participant_email) ? (
                    <img
                        src={CrownGl}
                        alt="Group Leader Crown"
                        className="absolute -top-[2%] z-10 object-contain"
                        style={{ height: '25px', width: '25px' }}
                    />
                ) : null}

                {allStream[props?.userData?.email || props?.userData?.participant_email] !== undefined ? (
                    <button
                        onClick={props.onPress}
                        className="h-full w-full bg-black"
                        style={props.elementStyle}
                    >
                        <button
                            onClick={() => {
                                if (
                                    showPeerKababMenu(
                                        { myEmail: profileData?.email },
                                        { clickedEmail: props?.userData?.email || props?.userData?.participant_email },
                                        sessionSettingData?.enableGroupIntereaction,
                                        sessionSettingData?.sessionMode
                                    )
                                ) {
                                    const emailExists = myGroup?.seats?.some((seat) => seat.email === props?.userData?.email);
                                    setShowSwapSeat(!emailExists);
                                    CheckBox(props?.userData);
                                    sessionSettingData?.sessionMode === 'Activity Mode' ? setActivityMenu(true) : setShowMenu(true);
                                }
                            }}
                            className="flex-1 flex justify-center items-center space-x-4 mt-5"
                        >
                            {allStream[props?.userData?.email || props?.userData?.participant_email] ? (
                                <>
                                    {/* <PeerView
                                        caller="TableElement"
                                        logicalMute={muteuser()}
                                        style={{ flex: 1, height: '100%', width: '100%', zIndex: 1 }}
                                        streamURL={allStream[props?.userData?.email || props?.userData?.participant_email]}
                                        peerEmail={props?.userData?.email || props?.userData?.participant_email}
                                        allStream={allStream}
                                        micIcon={amImute}
                                        isExpandedView={props?.isExpandedView}
                                        userDatax={props?.userData}
                                    /> */}
                                    <ParticipantNew name={props?.userData?.name}
                                    userData={props?.userData}
                                        id={props?.userData?.id}
                                        profilePhoto={props?.userData?.profilePhoto}
                                        size="5"
                                        radius="small"
                                        kebab={true}
                                        video="yes"
                                        audio="yes"
                                        isVideoOn={allStream[props?.userData?.email || props?.userData?.participant_email] ? true : false}
                                        streamArray={allStream[props?.userData?.email || props?.userData?.participant_email]}
                                    />
                                    {(props?.userData?.email || props?.userData?.participant_email) === props?.groupLeaderEmail && (
                                        <div className="absolute m-[0.4%]">
                                            <img
                                                src={CrownGl}
                                                alt="Group Leader Crown"
                                                className="object-contain"
                                                style={{ height: '2.6%', width: '2.6%' }}
                                            />
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div
                                    className="relative flex-1 h-[100px] w-[100px] bg-[#5B5D6B] flex items-center justify-center"
                                >
                                    <span
                                        className="text-white text-xl text-center"
                                        style={{ fontFamily: "'Lato', sans-serif" }}
                                    >
                                        {getFirsrLetterOfName(
                                            userData?.participant_name ||
                                            `${userData?.name || ''} ${userData?.Lname || ''}`.trim()
                                        )}
                                    </span>
                                    <div
                                        className="absolute bottom-[0.5%] flex flex-row w-full px-[2%] items-center justify-between"
                                    >
                                        <img
                                            src={videoOff}
                                            alt="Video Off"
                                            className="object-contain"
                                            style={{ height: '25%', width: '25%', filter: 'brightness(0) invert(1)' }}
                                        />
                                        {!amImute ? (
                                            <img
                                                src={mico}
                                                alt="Mic On"
                                                className="object-contain"
                                                style={{ height: '16%', width: '16%', filter: 'brightness(0) invert(1)' }}
                                            />
                                        ) : (
                                            <img
                                                src={micOff}
                                                alt="Mic Off"
                                                className="object-contain"
                                                style={{ height: '16%', width: '16%', filter: 'brightness(0) invert(1)' }}
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Three dot area */}
                            {showPeerKababMenu(
                                { myEmail: profileData?.email },
                                { clickedEmail: props?.userData?.email || props?.userData?.participant_email },
                                sessionSettingData?.enableGroupIntereaction,
                                sessionSettingData?.sessionMode
                            ) && (
                                    <div className="flex-1 absolute right-0 top-[0.5%] px-[0.7%]">
                                        <div className="h-[0.5%] w-[0.5%] rounded-full bg-white" />
                                        <div className="h-[0.5%] w-[0.5%] rounded-full bg-white my-[0.3%]" />
                                        <div className="h-[0.5%] w-[0.5%] rounded-full bg-white" />
                                    </div>
                                )}
                        </button>

                        {isVideoOn === false && (
                            <div className="h-full w-full bg-[#5B5D6B] flex items-center justify-center">
                                <span
                                    className="text-white text-xl text-center"
                                    style={{ fontFamily: "'Lato', sans-serif" }}
                                >
                                    {getFirsrLetterOfName(
                                        userData?.participant_name ||
                                        `${userData?.name || ''} ${userData?.Lname || ''}`.trim()
                                    )}
                                </span>
                                <div className="absolute bottom-[0.5%] flex flex-row w-full px-[2%] items-center justify-between">
                                    <img
                                        src={videoOff}
                                        alt="Video Off"
                                        className="object-contain"
                                        style={{ height: '25%', width: '25%', filter: 'brightness(0) invert(1)' }}
                                    />

                                    {mute ? (
                                        <img
                                            src={mico}
                                            alt="Mic On"
                                            className="object-contain"
                                            style={{ height: '16%', width: '16%', filter: 'brightness(0) invert(1)' }}
                                        />
                                    ) : (
                                        <img
                                            src={micOff}
                                            alt="Mic Off"
                                            className="object-contain"
                                            style={{ height: '16%', width: '16%', filter: 'brightness(0) invert(1)' }}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </button>
                ) : (
                    // Offline view of the user
                    <div
                        className="h-full w-full flex items-center justify-center bg-[#545455]"
                        style={props.elementStyle}
                    >
                        {acceptedBy &&
                            (acceptedBy === props?.userData?.email || acceptedBy === props?.userData?.participant_email) ? (
                            <div className="flex-1 h-full w-full flex items-center justify-center absolute bg-[rgba(33,32,37,0.93)]">
                                <div className="bg-[rgba(33,32,37,0.8)] px-[1%] py-[0.4%]">
                                    <span className="text-white text-xs font-medium" style={{ fontFamily: "'Lato', sans-serif" }}>
                                        In a Private Chat
                                    </span>
                                </div>
                            </div>
                        ) : (
                            <div className="h-full w-full flex items-center justify-center bg-[#545455]" style={props.elementStyle}>
                                <img
                                    src={offlineuser}
                                    alt="Offline User"
                                    className="object-contain"
                                    style={{ height: '100%', width: '100%' }}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>

            <ModalComp
                visible={showMenu}
                onRequestClose={() => setShowMenu(false)}
                swapSeat={showSwapSeat}
                onPressSwapSeat={() => {
                    sendRequestToSwapSeat();
                    setShowMenu(false);
                }}
                image2="/assets/bussinescard.png"
                text2="Share Visiting Card"
                onShareVisitingCard={() => shareVisitingCard()}
                image4={CheckCircle}
                text5="Give a Badge"
                image5="/assets/Badges.png"
                onPressBadge={() => {
                    setShowBadges(true);
                }}
                onVideoChat={() => goToVideoChat()}
            />

            {!hideKebab ? (
                <ActivityModal
                    visible={activityMenu}
                    onRequestClose={() => setActivityMenu(false)}
                    onVideoChat={() => goToVideoChat()}
                    onPressShareBadges={() => {
                        setActivityMenu(false);
                        setShowBadges(true);
                    }}
                    onPressSwapSeat={() => {
                        sendRequestToSwapSeat();
                        setShowMenu(false);
                    }}
                />
            ) : null}

            <div>
                <BadgesModal
                    visible={showBadges}
                    onSwipeDown={() => {
                        handleBadges();
                    }}
                    onRequestClose={setShowBadges}
                    onPressShareImage={(item) => {
                        setShareBadgesItem(() => {
                            return item;
                        });
                        setShowBadges(false);
                        setShowMenu(false);
                        sendBadges(item);
                    }}
                    onShowReceivedModal={() => {
                        setShowBadges(false);
                        setShareBadges(false);
                        setReceivedBadges(true);
                    }}
                    session_id={sessionData.id}
                    messageCount={0}
                    consoleDetailData={consoleDetailData}
                />
            </div>

            <div>
                <ShareBadgesModal
                    visible={showShareBadges}
                    onRequestClose={() => {
                        setShareBadges(false);
                        setReceivedBadges(false);
                        setShareBadgesItem(null);
                    }}
                    onPressShareButton={() => {
                        setShareBadges(false);
                        setReceivedBadges(false);
                        setShareBadgesItem(null);
                        setShowBadges(true);
                    }}
                    onPressBack={() => {
                        setShareBadges(false);
                        setReceivedBadges(false);
                        setShareBadgesItem(null);
                        setShowBadges(true);
                    }}
                    shareBadgesItem={shareBadgesItem}
                />
            </div>

            <SuccessModal
                visible={showModal}
                onRequestClose={() => {
                    setShowModal(false);
                }}
                message={message}
                onPress={() => {
                    setShowModal(false);
                }}
            />
        </>
    )
}

export default TableElement